import React, { FunctionComponent } from 'react';

// components
import ColorPicker from './ColorPicker';

interface OwnProps {
  displayPrimaryColorPicker: boolean;
  paywall_primary_color: string;
  handleClick: (displayPicker: string) => any;
  handleClose: (displayPicker: string) => any;
  handlePickerChange: (elementName: string) => any;
}

const PaywallModalConfigurationContent: FunctionComponent<OwnProps> = ({
  displayPrimaryColorPicker,
  paywall_primary_color,
  handleClick,
  handleClose,
  handlePickerChange,
}) => {
  return (
    <>
      <ColorPicker
        tag="primary_color_picker"
        showColorPicker={displayPrimaryColorPicker}
        displayPicker="displayPrimaryColorPicker"
        element_name="paywall_primary_color"
        background_color={paywall_primary_color}
        text="Primary color"
        handleClick={handleClick('displayPrimaryColorPicker')}
        handleClose={handleClose('displayPrimaryColorPicker')}
        handlePickerChange={handlePickerChange('paywall_primary_color')}
      />
    </>
  );
};

export default PaywallModalConfigurationContent;
